<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YDt25k/tc-custom/9781467440400.jpg?1737194763972" alt="This image is the cover for the book Toughest People to Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Toughest People to Love
      </h1>
      <p class="bookDescription body article font2">
        <p>People -- frustrating, confusing, disappointing, complicated -- are the most difficult part of leadership, and they challenge leaders everywhere, from leaders of many to managers of a few. In this book Chuck DeGroat addresses the flawed nature of people and offers wisdom for leaders of all types in dealing with just about anyone who is difficult to lead and to love.<br/><br/>Toughest People to Love explores the basics of how people "tick," encouraging leaders to examine and take care of themselves so that they can better understand and care for others. Based on DeGroat's wealth of experience as a pastor, professor, and therapist, this book -- both wise and practical -- is one that countless leaders will go back to time and again for valuable insights and renewed vision.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chuck DeGroat
      </h2>
      
      <p class="authorDescription body article">Chuck DeGroat is associate professor of pastoral care and counseling at Western Theological Seminary, Holland, Michigan, and former teaching pastor of City Church San Francisco and executive director of City Church&#39;s Counseling Center.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b617352